export default "__VITE_ASSET__BI94t9TE__"